import { useRouter, useSearchParams } from "next/navigation";
import { useEffect, useMemo } from "react";

export const useActiveLoginForm = () => {
  const router = useRouter();
  const searchParams = useSearchParams();

  const signupParam = searchParams.get("signup");
  const initialForm = useMemo<"signin" | "signup">(() => {
    return signupParam === "true" ? "signup" : "signin";
  }, [signupParam]);

  // Remove signup parameter from URL if it exists
  useEffect(() => {
    if (signupParam === "true") {
      const newSearchParams = new URLSearchParams(searchParams.toString());
      newSearchParams.delete("signup");
      const newUrl = newSearchParams.toString()
        ? `${window.location.pathname}?${newSearchParams.toString()}`
        : window.location.pathname;
      router.replace(newUrl, { scroll: false });
    }
  }, [signupParam]);

  return initialForm;
};
